import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioPulseraService {
  constructor(private requestUrlReporte: ReportesRequestService) {}

  public async getResponse(codigoBaseDatos: string, idAdmision: string) {
    try {
      const response = await this.requestUrlReporte.getRequest('pulsera/data', [
        codigoBaseDatos,
        { 'id-pre-admision': idAdmision }
      ]);

      if (response != null) {
        return response;
      } else {
        return null;
      }

    } catch (exception) {
      console.log(exception);
    }
  }
}


export interface ReportePulseraEntity {
  id: number;
  id_pre_admision: string;
  identificacion: string;
  tipo_documento: string;
  nombre: string;
  apellido: string;
  sexo: string;
  edad: string;
  fecha_pre_admision: Date;
  grupo_sanguineo: string;
}
